import { useState } from "react";
import AdminLogin from "../components/AdminLogin";
import AdminUploadForm from "../components/AdminUploadForm";
import AdminItemList from "../components/AdminItemList";
import { API } from "../utils/media";
import "../styles/AdminPage.css";

export default function AdminPage({
  shopItems,   setShopItems,
  classItems,  setClassItems,
  galleryItems, setGalleryItems,
  feedbackItems, setFeedbackItems,
  showToast,
}) {
  const [authed, setAuthed] = useState(false);
  const [tab, setTab] = useState("upload");

  if (!authed) {
    return <AdminLogin onAuth={() => setAuthed(true)} />;
  }

  async function handleAdd(dest, item, file) {
    const fd = new FormData();
    fd.append("dest", dest);
    fd.append("meta", JSON.stringify(item));
    if (file) fd.append("file", file);
    try {
      const res = await fetch(API.upload, { method: "POST", body: fd });
      const data = await res.json();
      if (!res.ok || !data.item) {
        showToast(data.error || "Upload failed on the server.");
        return;
      }
      item = data.item;
    } catch {
      showToast("Could not reach /api/upload.php on the server.");
      return;
    }
    if (dest === "shop")      setShopItems((p)  => [...p, item]);
    if (dest === "classroom") setClassItems((p) => [...p, item]);
    if (dest === "gallery")   setGalleryItems((p) => [...p, item]);
    if (dest === "feedback")  setFeedbackItems((p) => [...p, item]);
  }

  async function remove(dest, id, setter, msg) {
    try {
      await fetch(API.remove, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ dest, id }),
      });
    } catch {}
    setter((p) => p.filter((i) => String(i.id) !== String(id)));
    showToast(msg);
  }

  const tabs = [
    ["upload",    "Upload New"],
    ["gallery",   "Gallery"],
    ["shop",      "Shop Items"],
    ["classroom", "Classroom Sessions"],
    ["feedback",  "Customer Feedback"],
  ];

  return (
    <div className="admin-page">
      <div className="admin-header">
        <div className="admin-badge">
          <div className="admin-badge-dot" />
          Admin Panel Active
        </div>
        <h1>Gallery Management</h1>
        <p>Files save under uploads/gallery, uploads/shop, uploads/classroom, uploads/feedback.</p>
      </div>
      <div className="admin-tabs">
        {tabs.map(([t, label]) => (
          <button key={t} className={`admin-tab${tab === t ? " active" : ""}`} onClick={() => setTab(t)}>{label}</button>
        ))}
      </div>
      {tab === "upload" && <AdminUploadForm onAdd={handleAdd} showToast={showToast} />}
      {tab === "gallery" && <AdminItemList items={galleryItems} type="gallery" onRemove={(id) => remove("gallery", id, setGalleryItems, "Removed from gallery.")} />}
      {tab === "shop" && <AdminItemList items={shopItems} type="shop" onRemove={(id) => remove("shop", id, setShopItems, "Removed from shop.")} />}
      {tab === "classroom" && <AdminItemList items={classItems} type="classroom" onRemove={(id) => remove("classroom", id, setClassItems, "Session removed.")} />}
      {tab === "feedback" && <AdminItemList items={feedbackItems} type="feedback" onRemove={(id) => remove("feedback", id, setFeedbackItems, "Feedback removed.")} />}
    </div>
  );
}
